export const MAIN_FRAME_RESTORE_KEY = 'main-frame-restore'

export type MainFrameRestoreSnapshot = {
  sessionId: string
  formId: string
}

export function isRestorableMainFrameFormId(formId: string): boolean {
  return /^\d+$/.test(String(formId ?? '').trim())
}

export function persistMainFrameRestoreSnapshot(snapshot: MainFrameRestoreSnapshot): void {
  try {
    sessionStorage.setItem(MAIN_FRAME_RESTORE_KEY, JSON.stringify(snapshot))
  } catch {
    // ignore
  }
}

export function readMainFrameRestoreSnapshot(): MainFrameRestoreSnapshot | null {
  try {
    const raw = sessionStorage.getItem(MAIN_FRAME_RESTORE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<MainFrameRestoreSnapshot>
    const sessionId = String(parsed.sessionId ?? '').trim()
    const formId = String(parsed.formId ?? '').trim()
    if (!sessionId || !formId || !isRestorableMainFrameFormId(formId)) {
      if (formId && !isRestorableMainFrameFormId(formId)) {
        clearMainFrameRestoreSnapshot()
      }
      return null
    }
    return { sessionId, formId }
  } catch {
    return null
  }
}

export function clearMainFrameRestoreSnapshot(): void {
  try {
    sessionStorage.removeItem(MAIN_FRAME_RESTORE_KEY)
  } catch {
    // ignore
  }
}
